import createInfoBarMessageViewStateFactory from './createInfoBarMessageViewStateFactory';
import { getComposeHostItemIndex } from 'owa-addins-core';
import * as ComposeInfoBarHandlers from 'owa-mail-compose-store/lib/utils/infoBarHandlers';
export var addNotificationMessage = function (viewState) { return function (messageId) {
    ComposeInfoBarHandlers.infoBarAddHandler(viewState)(messageId, createInfoBarMessageViewStateFactory(getComposeHostItemIndex(viewState.composeId), messageId, removeNotificationMessage(viewState)));
}; };
export var removeNotificationMessage = function (viewState) { return function (messageId) {
    ComposeInfoBarHandlers.infoBarRemoveHandler(viewState)([messageId]);
}; };
export var getNotificationMessageIds = function (viewState) { return function () {
    return ComposeInfoBarHandlers.infoBarGetIdsHandler(viewState)();
}; };
//# sourceMappingURL=ComposeNotificationMessageAdapter.js.map